// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.F6lHU{display:inline-block}.QZglZ{display:block}.VCGP8{z-index:100}`, "",{"version":3,"sources":["webpack://./src/components/Menu/Menu.module.scss"],"names":[],"mappings":"AACI,OACI,oBAAA,CAGJ,OACI,aAAA,CAIR,OACI,WAAA","sourcesContent":[".anchor {\n    &Inline {\n        display: inline-block;\n    }\n\n    &Block {\n        display: block;\n    }\n}\n\n.dropdown {\n    z-index: 100;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"anchorInline": `F6lHU`,
	"anchorBlock": `QZglZ`,
	"dropdown": `VCGP8`
};
export default ___CSS_LOADER_EXPORT___;
